var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailIcon = function SvgEmailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 81 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#emailIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m3.623 14.403.222.176 36.889 29.407 36.46-29.406.22-.177h1.753c.736 0 1.333.596 1.333 1.333v48.528c0 .737-.597 1.333-1.333 1.333H1.833A1.333 1.333 0 0 1 .5 64.264V15.736c0-.737.597-1.333 1.333-1.333zm37.1 26.165L8.124 14.58h64.823z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "emailIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.5 0h80v80H.5z"
  })))));
};
export { SvgEmailIcon as ReactComponent };